import $ from 'jquery';

( function() {
	const conversation = $( '#conversation' );
	const conversationMessages = $('.c-conversation__item');

	if ( conversation.length ) {
		let messageDelay = 0;
		$.each( conversationMessages, function() {
			const message = $(this);
			messageDelay++;
			message.delay( messageDelay*2500 ).show( 1, function() {

				message.addClass( 'c-conversation__item--visible' );
				scrollToLastMessage();

				message.delay( 1500 ).show( 1, function() {
					message.addClass( 'c-conversation__item--show-content' );
					scrollToLastMessage();
				} );
			} );
		});

		function scrollToLastMessage(){
			$( '.c-conversation__container').animate( {
				scrollTop: $( '.c-conversation__container').prop( 'scrollHeight' ),
			} );
		}
	}
}())